import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink, RouterOutlet } from '@angular/router';
import { selectUrl } from '../../../store/router/router.state';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-package-library',
    imports: [
        AsyncPipe,
        MatTabLink,
        MatTabNav,
        MatTabNavPanel,
        RouterLink,
        RouterOutlet
    ],
    templateUrl: './package-library-page.component.html',
    styleUrl: './package-library-page.component.scss'
})
export class PackageLibraryPageComponent {

    constructor(private store: Store<AppState>) {
    }

    public url$ = this.store.select(selectUrl);
}
